import { render, staticRenderFns } from "./ElTreeEx.vue?vue&type=template&id=2f3deccc&scoped=true&"
import script from "./ElTreeEx.vue?vue&type=script&lang=js&"
export * from "./ElTreeEx.vue?vue&type=script&lang=js&"
import style0 from "./ElTreeEx.vue?vue&type=style&index=0&id=2f3deccc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3deccc",
  null
  
)

export default component.exports